<div class="row no-gutters mt-3" *ngIf="user.isVerified">
    <div class="col text-right">
        <button id="{{ idPrefix }}.twoFa.sms.btn.reset" 
                mat-flat-button
                (click)="reset(AuthenticationMethods.TOTP)"
        >
            {{ 'user_management.2fa.btn.reset' | translate | uppercase }}
        </button>
    </div>
</div>

<div class="mt-3" *ngIf="!user.isVerified">

    <p>{{ 'user_management.2fa.qr_code_verification_text' | translate }}</p>
    <p [innerHtml]="'user_management.2fa.totp_help' | translate : {link: 'https://support.dynarex.de/totp'}"></p>

    <p *ngIf="qrCode">
        <img src="{{ getQrCode() }}" alt="QR Code" />
    </p>

    <p>{{ secret || user.authentication_totp_secret }}</p>

    <div class="mt-3">
        <p>{{ 'user_management.2fa.verification_qr_code_text' | translate }}</p>
        
        <form (ngSubmit)="verifyOTP(AuthenticationMethods.TOTP, tan)">
            <div class="row">
                <div class="col-lg-5 col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{ 'user_management.2fa.code.placeholder' | translate }}</mat-label>
                        <input id="{{ idPrefix }}.twoFA.totp.input.code"
                            type="tel" matInput
                            name="code"
                            autocomplete="off"
                            [(ngModel)]="tan">
                    </mat-form-field>
                </div>
        
                <div class="col-lg-7 col-md-6 col-sm-12">
                    <button id="{{ idPrefix }}.twoFa.totp.btn.verifyCode" 
                            mat-flat-button
                            style="height: 49px;margin-top: 5px;"
                            color="accent"
                            type="submit"
                            [disabled]="!tan"
                    >
                        {{ 'user_management.2fa.btn.verify' | translate | uppercase }}
                    </button>
                </div>
            </div>
        </form>
    </div>

</div>
